import {
  createStore as createReduxStore,
  applyMiddleware,
  compose,
} from 'redux';
import { enableBatching } from 'redux-batched-actions';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { createBrowserHistory } from 'history';

import reducer from './reducer';

export const history = createBrowserHistory();

export const createStore = (
  initialState,
  { debugApi } = {},
  { reduxLogger } = {},
) => {
  const middleWares = [thunk.withExtraArgument(debugApi)];

  if (reduxLogger) {
    middleWares.push(
      createLogger({
        duration: true,
        collapsed: true,
        logErrors: true,
      }),
    );
  }

  const enhancers = [applyMiddleware(...middleWares)];

  const composeEnhancers =
    window.__DEV__ && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose;

  const store = createReduxStore(
    enableBatching(reducer(history)),
    initialState,
    composeEnhancers(...enhancers),
  );

  if (module.hot) {
    module.hot.accept('./reducer', () => {
      store.replaceReducer(require('./reducer').default);
    });
  }

  return store;
};
